module.exports = __webpack_public_path__ + "img/DSC_2906-xs.a326390b.png";